module.exports = __webpack_public_path__ + "static/arcade-0bce86660b47d7ccbf4cbaf545eff06d.jpg";